import { User } from './store/User';

const appendPendoScript = (apiKey: string) => {
  const existingScript = document.querySelector('script[data-pendo-agent="true"]');
  if (existingScript) return;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://cdn.pendo.io/agent/static/${apiKey}/pendo.js`;
  script.setAttribute('data-pendo-agent', 'true');
  document.head.appendChild(script);
};

export const bootstrapPendo = () => {
  const apiKey = process.env.REACT_APP_PENDO_API_KEY;
  if (!apiKey) return;
  appendPendoScript(apiKey);
};

export const initializePendo = (user: User) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const pendo = (window as any).pendo;
  if (!pendo) return;

  const options = {
    visitor: {
      id: user.id,
      email: user.email,
      full_name: `${user.firstName || ''} ${user.lastName || ''}`,
      role: user.role
    }
  };

  Object.assign(options, { account: { id: '', name: '' } });

  pendo?.initialize(options);
};
